import React from 'react';
import { ParameterType } from '@isyc-react/types';
import clsx from 'clsx';
export const BailleursParameterView = props => {
    var _a;
    const { field } = props;
    switch (field.parameterType) {
        case ParameterType.BOOLEAN_TYPE:
            return (React.createElement(React.Fragment, null, field.value === 'true' ? React.createElement(React.Fragment, null, "OUI") : React.createElement(React.Fragment, null, "NON")));
        case ParameterType.DEFAULT_VALUES_TYPE:
            return React.createElement(React.Fragment, null, (_a = field.comboCodeLabel) !== null && _a !== void 0 ? _a : 'Non renseigné');
        case ParameterType.DEFAULT_VALUES_MULTISELECT_TYPE:
        case ParameterType.MULTIFIELD_TYPE:
            return React.createElement(React.Fragment, null, field.comboCodeLabel ? field.comboCodeLabel.split('###').join(', ') : 'Non renseigné');
        default:
            return React.createElement(React.Fragment, null, field.value ? field.value : 'Non renseigné');
    }
};
export const BailleursParametersView = props => {
    const { code, parameters } = props;
    const field = parameters === null || parameters === void 0 ? void 0 : parameters.find(p => p.code === code);
    if (!field)
        return null;
    return (React.createElement("div", { className: 'row' },
        React.createElement("label", { className: 'col-auto p-0 pe-0 col-form-label text-darker-primary' },
            field.label,
            " :"),
        React.createElement("label", { className: clsx('col-auto p-0 ps-2 col-form-label fw-600 text-darker-primary', {
                'fst-italic': field.value !== undefined ||
                    field.value !== '' ||
                    field.comboCodeLabel !== '' ||
                    field.comboCodeLabel !== undefined,
            }) },
            React.createElement(BailleursParameterView, { field: field }))));
};
